import { emptySplitApi } from './index'

export const foundationDetailsService = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
        sendOnlineApplication: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/foundation-details/online-application`,
                method: "POST",
                body: model
            }),
        }),
        sendSuggestion: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/foundation-details/suggestion`,
                method: "POST",
                body: model
            }),
        }),
        getFunderForEdit: builder.query({
            query: ({ source, profileId }) => ({
                url: `api/v1/foundation-service/foundation-details/for-edit/${source}/${profileId}`,
                method: "GET",
            }),
        }),
        createUpdateRequest: builder.mutation({
            query: (model) => ({
                url: `api/v1/foundation-service/foundation-details/update-request`,
                method: "POST",
                body: model
            }),
        }),
        getUpdateRequestHistory: builder.query({
            query: ({ source, profileId }) => ({
                url: `api/v1/foundation-service/foundation-details/update-request/${source}/${profileId}`,
                method: "GET",
            }),
        }),
        getUpdateRequestPagedList: builder.mutation({
            query: (model) => ({
                url:
                    `api/v1/foundation-service/foundation-details/update-request/list?` +
                    `pageNumber=${model?.pageNumber || 0}` +
                    `&pageSize=${model?.pageSize || ""}` +
                    `&orderField=${model?.orderField || "createdAt"}` +
                    `&orderDirection=${model?.orderDirection || "desc"}` +
                    `&updateType=${model?.updateType || ""}`,
                method: "GET",
            }),
        }),
        applyUpdateRequest: builder.mutation({
            query: ({ id, indexName }) => ({
                url: `api/v1/foundation-service/foundation-details/update-request/${id}/apply`,
                method: "POST",
                body: { indexName }
            }),
        }),
        bulkApplyUpdateRequest: builder.mutation({
            query: ({ ids, indexName }) => ({
                url: `api/v1/foundation-service/foundation-details/update-request/bulk-apply`,
                method: "POST",
                body: { updateRequestIds: ids, indexName }
            }),
        }),
    }),
  overrideExisting: false,
});

export const {
    useSendOnlineApplicationMutation,
    useSendSuggestionMutation,
    useGetFunderForEditQuery,
    useCreateUpdateRequestMutation,
    useGetUpdateRequestHistoryQuery,
    useGetUpdateRequestPagedListMutation,
    useApplyUpdateRequestMutation,
    useBulkApplyUpdateRequestMutation,
} = foundationDetailsService;
